var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8061 11.9421C13.9771 11.9421 16.5478 9.46322 16.5478 6.40539C16.5478 3.34757 13.9771 0.868713 10.8061 0.868713C7.635 0.868713 5.06433 3.34757 5.06433 6.40539C5.06433 9.46322 7.635 11.9421 10.8061 11.9421Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70094 19.6332C1.69423 19.2325 1.78469 18.8358 1.96517 18.4749C2.36208 17.9635 2.86293 17.5354 3.43705 17.2168C4.01118 16.8982 4.64658 16.6956 5.30455 16.6216C6.23122 16.4341 7.17054 16.3103 8.11539 16.2509C9.86968 16.1004 11.6343 16.1004 13.3886 16.2509C14.3343 16.3092 15.274 16.4371 16.1994 16.6332C17.4847 16.888 19.0343 17.3977 19.5868 18.5097C19.7686 18.8706 19.863 19.2667 19.863 19.668C19.863 20.0692 19.7686 20.4653 19.5868 20.8263C19.0343 21.9846 17.4847 22.4479 16.1994 22.6911C15.2744 22.8919 14.3346 23.0236 13.3886 23.085C11.9621 23.1969 10.5295 23.2162 9.10031 23.1429C8.77034 23.1543 8.44012 23.131 8.11539 23.0734C7.17278 23.0169 6.23662 22.8851 5.31657 22.6795C4.64386 22.6291 3.99076 22.4371 3.4034 22.1169C2.81605 21.7967 2.30872 21.3561 1.91715 20.8263C1.74848 20.4506 1.6744 20.0417 1.70094 19.6332Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlack);
export default __webpack_public_path__ + "static/media/profile_black.00045283f4ca4f3bf253d013e89193d4.svg";
export { ForwardRef as ReactComponent };